import React from "react";
import { Divider } from "../Controls";
import PageActions from "./PageActions";
import texts from "../../assets/strings/faq.js";

import "./styles.less";

const FAQPage = () => (
  <div className="text-page faq">
    <h1>{texts.title}</h1>
    <div
      className="page-content"
      dangerouslySetInnerHTML={{ __html: texts.html }}
    />
    <PageActions />
  </div>
);

export default FAQPage;



// WEBPACK FOOTER //
// ./components/Pages/FAQ.js